"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetConfiguratorBase = void 0;
var rxjs_1 = require("rxjs");
var DashboardEventBus_1 = require("./DashboardEventBus");
var WidgetConfiguratorBase = (function () {
    function WidgetConfiguratorBase(widgetId) {
        var _this = this;
        this._widgetId = widgetId;
        console.debug("Script for widget configurator loaded: ".concat(this.constructor.name));
        this._startSavingParametersForWidgetSubscription = DashboardEventBus_1.DashboardEventBus.onStartSavingParametersForWidget()
            .pipe((0, rxjs_1.map)(function (subject) {
            var $widgetParameterElements = $('#widget-parameters-container [name$="-widget-parameter"]');
            return { subject: subject, $widgetParameterElements: $widgetParameterElements };
        }), (0, rxjs_1.filter)(function (_a) {
            var subject = _a.subject, $widgetParameterElements = _a.$widgetParameterElements;
            return _this._widgetId === subject.widgetId;
        }), (0, rxjs_1.switchMap)(function (_a) {
            var subject = _a.subject, $widgetParameterElements = _a.$widgetParameterElements;
            return (0, rxjs_1.of)({ subject: subject, $widgetParameterElements: $widgetParameterElements });
        }))
            .subscribe(function (_a) {
            var subject = _a.subject, $widgetParameterElements = _a.$widgetParameterElements;
            return __awaiter(_this, void 0, void 0, function () {
                var parameters;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.debug("Start saving parameters in configurator type '".concat(this.constructor.name, "' for widget id ").concat(subject.widgetId));
                            parameters = this.onStartSavingParametersForWidget($widgetParameterElements);
                            return [4, subject.onCompleteAsync(parameters)];
                        case 1:
                            _b.sent();
                            return [2];
                    }
                });
            });
        });
        DashboardEventBus_1.DashboardEventBus.onStopConfiguringParameters()
            .pipe((0, rxjs_1.take)(1))
            .subscribe(function () {
            console.debug("Script for widget configurator destroyed: ".concat(_this.constructor.name));
            _this._startSavingParametersForWidgetSubscription.unsubscribe();
        });
    }
    WidgetConfiguratorBase.prototype.getWidgetParameters = function ($widgetParameterElements) {
        var newParameters = {};
        $widgetParameterElements.each(function (index, element) {
            var _a, _b;
            if (element.classList.contains('form-check-input')) {
                var parameterName = (_b = (_a = element.getAttribute('name')) === null || _a === void 0 ? void 0 : _a.replace('-widget-parameter', '')) !== null && _b !== void 0 ? _b : '';
                if (parameterName !== '') {
                    if ($(element).is(':checked')) {
                        if (element.classList.contains('checkbox')) {
                            newParameters[parameterName] = true;
                        }
                        else {
                            newParameters[parameterName] = $("#".concat(element.id)).val();
                        }
                    }
                }
            }
            else {
                newParameters[element.id] = $("#".concat(element.id)).val();
            }
        });
        return newParameters;
    };
    return WidgetConfiguratorBase;
}());
exports.WidgetConfiguratorBase = WidgetConfiguratorBase;
